/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Code.
 * @export
 */
export const ICON_DATA_OBJECT = (
  <svg fill="none" height="16" viewBox="0 0 20 16" width="20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 3V5C2 5.55 1.55 6 1 6C0.45 6 0 6.45 0 7V9C0 9.55 0.45 10 1 10C1.55 10 2 10.45 2 11V13C2 14.66 3.34 16 5 16H7C7.55 16 8 15.55 8 15C8 14.45 7.55 14 7 14H5C4.45 14 4 13.55 4 13V11C4 9.7 3.16 8.58 2 8.17V7.83C3.16 7.42 4 6.3 4 5V3C4 2.45 4.45 2 5 2H7C7.55 2 8 1.55 8 1C8 0.45 7.55 0 7 0H5C3.34 0 2 1.34 2 3Z"
      fill="#3D3D3D"
    />
    <path
      d="M19 6C18.45 6 18 5.55 18 5V3C18 1.34 16.66 0 15 0H13C12.45 0 12 0.45 12 1C12 1.55 12.45 2 13 2H15C15.55 2 16 2.45 16 3V5C16 6.3 16.84 7.42 18 7.83V8.17C16.84 8.58 16 9.69 16 11V13C16 13.55 15.55 14 15 14H13C12.45 14 12 14.45 12 15C12 15.55 12.45 16 13 16H15C16.66 16 18 14.66 18 13V11C18 10.45 18.45 10 19 10C19.55 10 20 9.55 20 9V7C20 6.45 19.55 6 19 6Z"
      fill="#3D3D3D"
    />
  </svg>
);
